import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import { ESort } from '../../Context/app-type';

export default function SortsToys() {
  const { sorts, setSortOptions } = React.useContext(AppContext);
  const handleSortChange = (event: React.FormEvent<HTMLSelectElement>) => {
    const { value } = event.target as HTMLSelectElement;
    setSortOptions(value as ESort);
  };
  return (
    <select
      value={sorts}
      onChange={handleSortChange}
      name=""
      id=""
      className="sort-select"
      style={{
        backgroundImage: `url(./assets/svg/arrow-down.svg)`,
      }}
    >
      <option value={ESort.nameAlphaDown}>По названию от «А» до «Я»</option>
      <option value={ESort.nameAlphaUp}>По названию от «Я» до «А»</option>
      <option value={ESort.yearDateDecrease}>
        По году приобретения по возрастанию
      </option>
      <option value={ESort.yearDateIncrease}>
        По году приобретения по убыванию
      </option>
    </select>
  );
}
